module.exports = __webpack_public_path__ + "static/media/verifiedIcon.5c60dbc2.svg";